var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 41,
    rx: 20.5,
    fill: "url(#paint0_linear_1494_505)",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_505)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.386 27V13.998H45.75V26.01H49.38V27H44.386ZM50.6973 27V16.11H52.0393V27H50.6973ZM51.3793 14.768C51.1593 14.768 50.9686 14.6947 50.8073 14.548C50.6606 14.3867 50.5873 14.2033 50.5873 13.998C50.5873 13.778 50.6606 13.602 50.8073 13.47C50.9686 13.3233 51.1593 13.25 51.3793 13.25C51.5846 13.25 51.7679 13.3233 51.9293 13.47C52.0906 13.602 52.1713 13.778 52.1713 13.998C52.1713 14.2033 52.0906 14.3867 51.9293 14.548C51.7679 14.6947 51.5846 14.768 51.3793 14.768ZM57.0111 27.154C56.2191 27.154 55.6031 27.0587 55.1631 26.868C54.7231 26.6627 54.4151 26.3473 54.2391 25.922C54.0631 25.482 53.9751 24.9027 53.9751 24.184V23.238H55.3611V24.492C55.3611 25.1813 55.4784 25.658 55.7131 25.922C55.9477 26.186 56.3731 26.318 56.9891 26.318C57.5317 26.318 57.9277 26.186 58.1771 25.922C58.4411 25.658 58.5731 25.2107 58.5731 24.58V23.964C58.5731 23.6267 58.5217 23.3407 58.4191 23.106C58.3164 22.8567 58.1184 22.6293 57.8251 22.424C57.5464 22.2187 57.1504 22.0133 56.6371 21.808C56.1531 21.6173 55.7277 21.412 55.3611 21.192C54.9944 20.972 54.7011 20.6933 54.4811 20.356C54.2757 20.0187 54.1731 19.586 54.1731 19.058V18.398C54.1731 17.6207 54.3931 17.0193 54.8331 16.594C55.2877 16.154 56.0504 15.934 57.1211 15.934C57.8251 15.934 58.3824 16.0293 58.7931 16.22C59.2184 16.4107 59.5264 16.7187 59.7171 17.144C59.9224 17.5693 60.0251 18.1193 60.0251 18.794V19.718H58.6831V18.662C58.6831 17.9287 58.5584 17.43 58.3091 17.166C58.0597 16.8873 57.6637 16.748 57.1211 16.748C56.5051 16.748 56.0871 16.8947 55.8671 17.188C55.6617 17.4813 55.5591 17.848 55.5591 18.288V18.882C55.5591 19.2927 55.6471 19.63 55.8231 19.894C56.0137 20.158 56.2777 20.378 56.6151 20.554C56.9524 20.73 57.3557 20.9133 57.8251 21.104C58.2504 21.28 58.6244 21.4707 58.9471 21.676C59.2844 21.8667 59.5484 22.1307 59.7391 22.468C59.9297 22.8053 60.0251 23.2673 60.0251 23.854V24.36C60.0251 24.9467 59.9297 25.4527 59.7391 25.878C59.5631 26.2887 59.2551 26.604 58.8151 26.824C58.3751 27.044 57.7737 27.154 57.0111 27.154ZM64.352 27.022C64.0294 27.022 63.736 26.9853 63.472 26.912C63.208 26.8387 62.9807 26.7213 62.79 26.56C62.5994 26.384 62.4527 26.164 62.35 25.9C62.2474 25.6213 62.196 25.2767 62.196 24.866V16.968H61.228V16.264L62.284 16.11L62.526 14.064H63.56V16.11H65.914V16.968H63.56V24.624C63.56 25.0347 63.6334 25.3793 63.78 25.658C63.9267 25.9367 64.2494 26.076 64.748 26.076C64.9534 26.076 65.1734 26.0687 65.408 26.054C65.6427 26.0247 65.8114 26.01 65.914 26.01V26.89C65.7967 26.89 65.5914 26.912 65.298 26.956C65.0047 27 64.6894 27.022 64.352 27.022ZM70.1207 27.198C69.3873 27.198 68.7933 27.1173 68.3387 26.956C67.884 26.78 67.554 26.4647 67.3487 26.01C67.1433 25.5553 67.0407 24.8953 67.0407 24.03V18.596C67.0407 17.5693 67.268 16.8653 67.7227 16.484C68.192 16.1027 68.962 15.912 70.0327 15.912C71.074 15.912 71.822 16.1027 72.2767 16.484C72.746 16.8653 72.9807 17.5693 72.9807 18.596V21.412H68.4047V24.492C68.4047 25.196 68.5147 25.6873 68.7347 25.966C68.9547 26.23 69.402 26.362 70.0767 26.362C70.6927 26.362 71.1033 26.23 71.3087 25.966C71.514 25.702 71.6167 25.2107 71.6167 24.492V23.084H72.9807V24.008C72.9807 24.8587 72.878 25.5187 72.6727 25.988C72.4673 26.4427 72.152 26.758 71.7267 26.934C71.316 27.11 70.7807 27.198 70.1207 27.198ZM68.4047 20.708H71.6167V18.552C71.6167 17.936 71.514 17.4887 71.3087 17.21C71.1033 16.9313 70.678 16.792 70.0327 16.792C69.3873 16.792 68.9547 16.9313 68.7347 17.21C68.5147 17.4887 68.4047 17.936 68.4047 18.552V20.708ZM74.9316 27V16.11H76.0536L76.2296 17.276C76.347 16.836 76.6183 16.4987 77.0436 16.264C77.469 16.0293 77.909 15.912 78.3636 15.912C79.141 15.912 79.7056 16.0513 80.0576 16.33C80.4243 16.594 80.659 16.946 80.7616 17.386C80.8643 17.8113 80.9156 18.2807 80.9156 18.794V27H79.5516V18.992C79.5516 18.728 79.5443 18.4713 79.5296 18.222C79.515 17.9727 79.4563 17.7527 79.3536 17.562C79.2656 17.3567 79.1116 17.1953 78.8916 17.078C78.6716 16.9607 78.349 16.902 77.9236 16.902C77.557 16.902 77.2563 16.9753 77.0216 17.122C76.8016 17.254 76.633 17.4153 76.5156 17.606C76.413 17.782 76.3396 17.9507 76.2956 18.112V27H74.9316Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3999 18.3008C14.4189 18.3205 15.4296 18.489 16.3999 18.8008",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3999 20.0703C20.7962 20.949 21.962 22.1491 22.7999 23.5703",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.31 3.31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25.0703C23.8339 26.0099 24.0685 26.9819 24.2 27.9703",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.1895C13 23.1895 19.5 23.1895 20.2 29.6895",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 13C14.3 13 29.6 13.4 28.79 27.3",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_505",
    x1: 3,
    y1: 15.6341,
    x2: 85.4847,
    y2: 20.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1097C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57366,
    stopColor: "#16769E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1097C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_505",
    x1: 2.85393,
    y1: 15.9024,
    x2: 38.1805,
    y2: 16.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1097C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57366,
    stopColor: "#78ADC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1097C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/Listen.931d7fcd8441b0e35aac328e49aacd1d.svg";
export { ForwardRef as ReactComponent };